var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: 20,
    height: 22,
    strokeWidth: 0.5
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.614.21a1 1 0 00-1.228 0l-9 7A1 1 0 000 8v11a3 3 0 003 3h14a3 3 0 003-3V8a1 1 0 00-.386-.79l-9-7zM14 20h3a1 1 0 001-1V8.49l-8-6.223-8 6.222V19a1 1 0 001 1h3v-9a1 1 0 011-1h6a1 1 0 011 1v9zm-6 0v-8h4v8H8z"
  })));
}
export default SvgHome;